import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.regexp.split";
import { parseDrawing } from './drawing.js';
import { parseTags } from './tags.js';
export function parseText(text) {
  var pairs = text.split(/{([^{}]*?)}/);
  var parsed = [];
  if (pairs[0].length) {
    parsed.push({
      tags: [],
      text: pairs[0],
      drawing: []
    });
  }
  for (var i = 1; i < pairs.length; i += 2) {
    var tags = parseTags(pairs[i]);
    var isDrawing = tags.reduce(function (v, tag) {
      return tag.p === undefined ? v : !!tag.p;
    }, false);
    parsed.push({
      tags: tags,
      text: isDrawing ? '' : pairs[i + 1],
      drawing: isDrawing ? parseDrawing(pairs[i + 1]) : []
    });
  }
  return {
    raw: text,
    combined: parsed.map(function (frag) {
      return frag.text;
    }).join(''),
    parsed: parsed
  };
}